import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["text", "children"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from './BaseButton';
import IconButtonGy from './IconButtonGy';
import LinkButton from './LinkButton';
import SplitButton from './SplitButton';
import { basePropTypes, StyledButton } from './utils';
import { AddOutlinedIcon, EditIcon } from '../icons';
const ContainedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "contained"
}, props));
const OutlinedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "outlined"
}, props));
const TextButton = props => /*#__PURE__*/React.createElement(BaseButton, props);
const CreateButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  color: props.color || 'primary',
  text: props.text || 'Create'
}));
const SaveButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  type: "submit",
  color: props.color || 'primary',
  text: props.text || 'Save'
}));
const CancelButton = props => /*#__PURE__*/React.createElement(OutlinedButton, _extends({}, props, {
  color: props.color || 'secondary',
  text: props.text || 'Cancel'
}));
const IconButtonAdd = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: AddOutlinedIcon,
  label: props.label || 'Add'
}));
const IconButtonEdit = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: EditIcon,
  label: props.label || 'Edit'
}));
const CustomButton = _ref => {
  let {
      text,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledButton, rest, text, children);
};
const IconTextButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  color: "primary",
  variant: "contained",
  startIcon: props === null || props === void 0 ? void 0 : props.icon
}), props === null || props === void 0 ? void 0 : props.text);
const IconTextButtonOutlined = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  variant: "outlined",
  startIcon: props === null || props === void 0 ? void 0 : props.icon
}), props === null || props === void 0 ? void 0 : props.text);
const IconTextButtonNonPrimary = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  variant: "contained",
  startIcon: props === null || props === void 0 ? void 0 : props.icon
}), props === null || props === void 0 ? void 0 : props.text);
CustomButton.propTypes = basePropTypes;
ContainedButton.propTypes = basePropTypes;
TextButton.propTypes = basePropTypes;
LinkButton.propTypes = basePropTypes;
CreateButton.propTypes = _objectSpread(_objectSpread({}, basePropTypes), {}, {
  float: PropTypes.string
});
OutlinedButton.propTypes = basePropTypes;
SaveButton.propTypes = basePropTypes;
CancelButton.propTypes = basePropTypes;
IconButtonAdd.propTypes = _objectSpread(_objectSpread({}, basePropTypes), {}, {
  children: PropTypes.any,
  label: PropTypes.string
});
IconButtonEdit.propTypes = _objectSpread(_objectSpread({}, basePropTypes), {}, {
  children: PropTypes.any,
  label: PropTypes.string
});
export { CustomButton, TextButton as Button, ContainedButton, TextButton, LinkButton, OutlinedButton, SaveButton, CancelButton, CreateButton, IconButtonGy as IconButton, IconButtonAdd, IconButtonEdit, SplitButton, IconTextButton, IconTextButtonNonPrimary, IconTextButtonOutlined };